/**
 * UsuariosMunicipal.tsx — Gestão de equipe do painel municipal.
 * Usa o componente genérico EquipeManager com MUNICIPAL_CONFIG.
 */
import { EquipeManager, buildMunicipalConfig } from '../../components/equipe';
import { useAuthStore } from '../../store/authStore';

export function UsuariosMunicipal() {
  const municipioId = useAuthStore((s) => s.user?.municipioId);

  if (!municipioId) {
    return (
      <div className="admin-page" style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
        Nenhum município vinculado ao seu perfil.
      </div>
    );
  }

  return <EquipeManager config={buildMunicipalConfig(municipioId)} />;
}
